import React, { useState } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import sortBy from 'lodash/sortBy'

import { ValueSelector, CheckboxField } from 'discada/dist/Form'
import Collection from 'components/widgets/Collection'
import { getHasMdrive } from 'selectors/appStatusSelectors'

import {
  getQuoteValue,
  getAvailableSurveyValues,
} from 'selectors/quoteSelectors'

import './DefaultSection.scss'

let terms = {
  loanTerms: [
    12,
    18,
    24,
    30,
    36,
    42,
    48,
    54,
    60,
    63,
    66,
    72,
    75,
    78,
    84,
    88,
    90,
    96,
  ],
  leaseTerms: [
    12,
    15,
    18,
    21,
    24,
    25,
    26,
    27,
    28,
    30,
    31,
    32,
    33,
    34,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    48,
    49,
    50,
    51,
    52,
    54,
    57,
    60,
    66,
    72,
  ],
}

export function DefaultSection(props) {
  let {
      label,
      labelRenderer,
      selected,
      collectionHeaders,
      values = [],
      addItem = () => {},
      removeItem = () => {},
      itemRenderer = () => {},
      onChange = () => {},
      sort = vals => sortBy(vals, 'value'),
      className,
      withConfig,
      allowCustom,
      customFieldLabel,
      showDiff,
      children,
      configType = 'classic',
      valueKey,
      valuesKey,
    } = props,
    [showConfig, setShowConfig] = useState(false),
    toggleConfig = () => setShowConfig(!showConfig),
    applyVal = value => onChange(value),
    toggleTerms = terms[valuesKey] || terms[valueKey] || []

  return (
    <div
      className={c('value-selector-wrapper', 'default-section', className, {
        'default-section-open': withConfig && showConfig,
        'default-section-with-config': withConfig,
      })}
    >
      <p className="value-selector-label">{label}</p>
      {(!withConfig || !showConfig) &&
        (values.length ? (
          <ValueSelector
            size="small"
            values={sort(values)}
            selected={selected}
            onChange={applyVal}
            allowCustom={allowCustom}
            customFieldLabel={customFieldLabel}
            labelRenderer={
              labelRenderer || (v => (!showDiff ? v.label : v.diffLabel))
            }
          />
        ) : (
          <span className="empty">No options avalable</span>
        ))}

      {withConfig && showConfig && itemRenderer && configType === 'classic' && (
        <Collection
          headers={collectionHeaders}
          className={c('quote-config-collection')}
          items={values}
          addItem={addItem}
          removeItem={removeItem}
          itemRenderer={itemRenderer}
        />
      )}

      {withConfig && showConfig && itemRenderer && configType === 'toggles' && (
        <div className="term-toggles-config">
          {toggleTerms.map(t => {
            let term = t.toString(),
              indexOf = values.map(v => v.value.toString()).indexOf(term),
              checked = indexOf > -1,
              onClick = () =>
                checked
                  ? removeItem(indexOf)
                  : addItem({
                      overrideStarter: {
                        value: parseInt(term, 10),
                        label: term,
                        default: false,
                      },
                    })

            return (
              <CheckboxField
                inline
                key={t}
                label={t}
                value={t}
                onClick={onClick}
                checked={checked}
              />
            )
          })}
        </div>
      )}

      {withConfig && (
        <p className="default-section-toggler">
          {!showConfig && (
            <span onClick={toggleConfig}>Add/Remove Options</span>
          )}
          {showConfig && <span onClick={toggleConfig}>Close</span>}
        </p>
      )}

      {children && <div className="default-section-children">{children}</div>}
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    configType:
      (getHasMdrive(state) &&
        (op.valueKey === 'loanTerms' || op.valueKey === 'leaseTerms')) ||
      (op.valuesKey === 'loanTerms' || op.valuesKey === 'leaseTerms')
        ? 'toggles'
        : 'classic',
    selected: op.hasOwnProperty('selected') // && !isNull(op.selected)
      ? op.selected
      : getQuoteValue(state, op.vehicleId, op.quoteId, op.valueKey),
    values:
      op.values ||
      getAvailableSurveyValues(
        state,
        op.vehicleId,
        op.quoteId,
        op.mode,
        op.valueKey,
        op.valuesKey,
        op.allowAll,
        op.hideAlt,
      ),
  }
}

export default connect(mapStateToProps)(DefaultSection)
